import { Text, View } from '@react-pdf/renderer';
import { ProReportCorrespondentAdvice } from '../../../models/pro.model';
import { formatAndRenderPdfTextContentHtml } from '../../../utils/pro-report-helpers.utils';
import styles from '../pro-report-pdf-styles';

interface CorrespondentFeedbackProps {
  correspondentDescription: string | null;
  correspondentAdvice:
    | ProReportCorrespondentAdvice[]
    | string
    | undefined
    | null;
}

function CorrespondentFeedback({
  correspondentDescription,
  correspondentAdvice,
}: CorrespondentFeedbackProps) {
  if (!correspondentAdvice) {
    return (
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableHeaderFullWidth}>Correspondent advice</Text>
        <Text style={styles.tableCellFullWidth}>No feedback provided.</Text>
      </View>
    );
  }
  return (
    <View>
      <View wrap={false} style={styles.table}>
        <Text style={styles.tableHeaderFullWidth}>Correspondent advice</Text>
      </View>
      {typeof correspondentAdvice === 'string' && (
        <View wrap={false} style={styles.table}>
          {correspondentDescription && (
            <Text style={styles.tableSubHeaderFullWidth}>
              <Text style={{ fontWeight: 700 }}>Correspondent:</Text>{' '}
              {correspondentDescription || 'N/A'}
            </Text>
          )}
          <Text style={styles.tableCellFullWidth}>
            <Text style={{ fontWeight: 700 }}>Advice:</Text>{' '}
            {formatAndRenderPdfTextContentHtml(
              correspondentAdvice,
              'No feedback provided.'
            )}
          </Text>
        </View>
      )}
      {Array.isArray(correspondentAdvice) &&
        correspondentAdvice.length > 0 &&
        correspondentAdvice.map((advice) => (
          <View style={styles.table}>
            {advice.correspondent && (
              <View key={advice.correspondent} style={styles.tableRow}>
                <Text style={styles.tableSubHeaderFullWidth}>
                  <Text style={{ fontWeight: 700 }}>Correspondent:</Text>{' '}
                  {advice.correspondent}
                </Text>
              </View>
            )}
            <View key={advice.correspondent} style={styles.tableCellFullWidth}>
              {formatAndRenderPdfTextContentHtml(
                advice.advice,
                'No feedback provided.',
                {
                  prependSubHeader: 'Advice:',
                }
              )}
            </View>
          </View>
        ))}
    </View>
  );
}
export default CorrespondentFeedback;
